<template>
  <div :class="b({ mix: mixClassName, isMobileView })">
    <button
      :class="b('button', {
        mix: className,
        isHorizon,
        isDark,
        isLeft,
        isRight,
        withoutShadow,
        withLine,
        disabled,
        isMobileView,
        isSelected,
        isTab: mixClassName === 'isTab',
      })"
      :style="buttonStyle"
      @click="handleClick"
      :type="type || 'button'"
      :disabled="disabled"
    >
      <!-- Режим редактирования -->
      <a-input
        v-if="isEdit"
        :class="b('text-input')"
        placeholder="Enter button text"
        v-model:value="editableText"
      />
      <!-- Обычный режим -->
      <span v-else>
        <slot />
      </span>
      <double-arrow-icon
        v-if="isMobile && (isLeft || isRight)"
        :class="b('arrow-icon', { isLeft, isRight, isHorizon, isMobileView })"
        :stroke="arrowStroke"
        :stroke-width="2"
      />
    </button>
    <div
      v-if="withLine"
      :class="b('line', { isHorizon, isDark, disabled, isMobileView })"
    />
  </div>
</template>

<script>
import bem from '@/utils/bem';
import useMobileStyle from '@/mixins/useMobileStyle';
import DoubleArrowIcon from './double-arrow-icon.vue';
import styles from './custom-button-style.scss';

const b = bem('custom-button', styles);

export default {
  name: 'CustomButton',
  components: {
    DoubleArrowIcon,
  },
  mixins: [useMobileStyle],
  props: {
    className: {
      type: String,
      default: '',
    },
    backgroundImage: {
      type: [String, Object],
      default: '',
    },
    buttonFunc: {
      type: Function,
      default: () => {},
    },
    buttonLink: {
      type: String,
      default: '',
    },
    isHorizon: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    isLeft: {
      type: Boolean,
      default: false,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    withoutShadow: {
      type: Boolean,
      default: false,
    },
    widthTab: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
      validator: (value) => ['button', 'submit', 'reset'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    withLine: {
      type: Boolean,
      default: false,
    },
    mixClassName: {
      type: String,
      default: '',
    },
    isMobileView: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editText: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    b() {
      return b;
    },
    isMobile() {
      return this.isMobileDisplay;
    },
    buttonStyle() {
      const style = {};
      if (this.backgroundImage) {
        style.backgroundImage = `url(${this.backgroundImage})`;
      }
      if (this.widthTab) {
        style.width = this.widthTab;
      }
      return style;
    },
    arrowStroke() {
      return this.isHorizon ? '#FFFFFF' : '#2C3E50';
    },
    editableText: {
      get() {
        return this.editText;
      },
      set(value) {
        this.$emit('update-text', value);
      },
    },
  },
  methods: {
    handleClick() {
      // No navigation in admin panel - only emit click event
      // buttonFunc is called only if provided and not default
      if (this.buttonFunc && typeof this.buttonFunc === 'function') {
        this.buttonFunc();
      }
    },
    updateText(event) {
      this.$emit('update-text', event.target.value);
    },
  },
  data() {
    return {
      size: 1024,
    };
  },
};
</script>
